<template>
  <div id="app">
    <app-preloader :loading="this.loading"></app-preloader>
    <PageOverlay></PageOverlay>
    <BodyOverlay></BodyOverlay>
    <Modal v-if="showModal"></Modal>
    <Social></Social>

    <app-header />
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
/*name="fade" mode="out-in" @enter="enter" @leave="leave" */
const url = process.env.VUE_APP_URL;

import Shop from "@/components/shared/Shop";
import Sponsors from "@/components/shared/Sponsors";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";

import Preloader from "@/components/shared/Preloader";

const PageOverlay = () => import("@/components/shared/PageOverlay.vue");
const BodyOverlay = () => import("@/components/shared/BodyOverlay.vue");
const Modal = () => import("@/components/shared/Modal.vue");
const Social = () => import("@/components/shared/Social.vue");

import { getScrollState } from "scroll-lock";

window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty(
    "--scroll-y",
    `${window.scrollY}px`
  );
});

export default {
  name: "app",
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
    showModal() {
      var showModal = this.$store.getters.showModal;
      return showModal.show;
    },
    bodyOverlay() {
      var bodyOverlay = this.$store.getters.bodyOverlay;
      return bodyOverlay;
    },
  },
  methods: {
    isMobile() {
      if (document.documentElement.clientWidth < 769) {
        return this.$store.dispatch("determineResolution", true);
      } else {
        return this.$store.dispatch("determineResolution", false);
      }
    },
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    document.documentElement.classList.remove("page-update");
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.isMobile();
    window.addEventListener("resize", this.isMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isMobile);
  },
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "app-preloader": Preloader,
    Modal,
    BodyOverlay,
    PageOverlay,
    Social,
    "app-shop": Shop,
    "app-sponsors": Sponsors,
  },
};
</script>

<style lang="scss">
</style>
 